import {Dialog, Transition} from '@headlessui/react'
import {Fragment, useState} from 'react'
import {EmailInput} from './forms/EmailInput'
import TextInput from './forms/TextInput'
import BlueButtonWithIcon from './forms/Buttons/BlueButtonWithIcon'
import GreenButton from './forms/Buttons/GreenButton'
import {PlusSmallIcon} from '@heroicons/react/24/outline'
import {useForm} from "react-hook-form";
import {userActions} from "../actions";
import CheckboxInput from "./forms/CheckboxInput";
import Error from "./Alert/Error";
import {useDispatch} from "react-redux";
import {fieldRequiredMessage} from "../errors/errors";
import SubmitButton from "./forms/Buttons/SubmitButton";
import {initialFormData} from "../utils/constant";

export default function InvitationModal() {
    let [isOpen, setIsOpen] = useState(false)
    const {
        handleSubmit,
        register,
        setValue,
        reset,
        formState: { errors },
    } = useForm();
    const [loading, setLoading] = useState(false);
    const user = JSON.parse(localStorage.getItem("user"));
    const dispatch = useDispatch();
    const dataInit = {
        CocUserId: user?.data.id,
        companyName: "",
        email: "",
        companyExpertise: [],
    };
    const [formData, setFormData] = useState(dataInit);
    const [errorCount, setErrorCount] = useState(0);


    const onSubmitForm = async (data) => {
        data.CocUserId = user?.data.id;
        dispatch(userActions.invite(data));
        reset();
        setIsOpen(false);
    };

    const handleExpertiseChange = (e) => {
        const value = e.target.value;
        let updatedExpertise = [...formData.companyExpertise];
        if (updatedExpertise.includes(value)) {
            updatedExpertise = updatedExpertise.filter((item) => item !== value);
        } else {
            updatedExpertise.push(value);
        }
        setFormData((prevFormData) => ({
            ...prevFormData,
            companyExpertise: updatedExpertise,
        }));
    };


    function closeModal() {
        setIsOpen(false)
        reset();
    }

    function openModal() {
        setIsOpen(true)
        reset();
    }

    return (
        <>
            <div>
                <BlueButtonWithIcon Event={openModal}>
                    <PlusSmallIcon className="h-6 w-6 mr-2"/> Invite a company to join the list of partners
                </BlueButtonWithIcon>
            </div>

            <Transition appear show={isOpen} as={Fragment}>
                <Dialog as="div" className="relative z-50" onClose={closeModal}>
                    <Transition.Child
                        as={Fragment}
                        enter="ease-out duration-300"
                        enterFrom="opacity-0"
                        enterTo="opacity-100"
                        leave="ease-in duration-200"
                        leaveFrom="opacity-100"
                        leaveTo="opacity-0"
                    >
                        <div className="fixed inset-0 bg-black bg-opacity-25"/>
                    </Transition.Child>

                    <div className="fixed inset-0 overflow-y-auto">
                        <div className="flex min-h-full items-center p-4">
                            <Transition.Child
                                as={Fragment}
                                enter="ease-out duration-300"
                                enterFrom="opacity-0 scale-95"
                                enterTo="opacity-100 scale-100"
                                leave="ease-in duration-200"
                                leaveFrom="opacity-100 scale-100"
                                leaveTo="opacity-0 scale-95"
                            >
                                <Dialog.Panel
                                    className="w-full max-w-4xl transform overflow-hidden rounded-2xl bg-white p-6 align-middle shadow-xl transition-all mx-auto">

                                    <img className="hover:cursor-pointer block ml-auto mb-9"
                                         onClick={() => setIsOpen(false)} src="/assets/icons/close.svg" alt=""/>

                                    <Dialog.Title
                                        as="p"
                                        className="text-sm font-normal leading-6 text-center text-[#232323] mb-9"
                                    >
                                        You may invite your Partner, or service provider to join COC list of partners to
                                        offer their services as part of
                                        COC import.meta. An email will be automatically sent to the contact email adress
                                        inviting to register as a COC Partner
                                    </Dialog.Title>
                                    <form onSubmit={handleSubmit(onSubmitForm)}>
                                        <h2 className="font-bold text-left text-[#3D4196] text-lg">Contact details</h2>

                                        <div className="grid grid-cols-2">


                                            <div className="w-3/4 mt-3">
                                                <TextInput
                                                    type="text"
                                                    placeholder="Your Company Name"
                                                    label="Company Name"
                                                    name="companyName"
                                                    id="companyName"
                                                    register={{
                                                        ...register("CompanyName", { required: true, maxLength: 30 }),
                                                    }}
                                                    onChange={(e) => setValue("CompanyName", e.target.value)}
                                                />
                                                {errors.CompanyName && errors.CompanyName.type === "required" && (
                                                    <Error
                                                        key={errorCount}
                                                        text={fieldRequiredMessage("Company Name")}
                                                    />
                                                )}

                                                <div className="font-bold text-left text-[#3D4196] text-lg my-4">Company
                                                    Expertise
                                                </div>
                                                <div className="checkItems">
                                                    <CheckboxInput
                                                        id="ghg"
                                                        name="ghg"
                                                        register={{
                                                            ...register("CompanyExpertise", {required: true}),
                                                        }}
                                                        label="GHG accounting and reporting"
                                                        value="1"
                                                        onChange={handleExpertiseChange}
                                                    />

                                                    <CheckboxInput
                                                        id="accessProvider"
                                                        name="accessProvider"
                                                        register={{
                                                            ...register("CompanyExpertise", {required: true}),
                                                        }}
                                                        label="Carbon market access provider"
                                                        value="2"
                                                        onChange={handleExpertiseChange}
                                                    />

                                                    <CheckboxInput
                                                        id="assurance"
                                                        name="assurance"
                                                        register={{
                                                            ...register("CompanyExpertise", {required: true}),
                                                        }}
                                                        label="Verification, assurance provider"
                                                        value="3"
                                                        onChange={handleExpertiseChange}
                                                    />

                                                    <CheckboxInput
                                                        id="other"
                                                        name="other"
                                                        register={{
                                                            ...register("CompanyExpertise", {required: true}),
                                                        }}
                                                        label="Other"
                                                        value="4"
                                                        onChange={handleExpertiseChange}
                                                    />
                                                    {errors.CompanyExpertise && (
                                                        <Error
                                                            key={errorCount}
                                                            text={"Please select at least one option"}
                                                        />
                                                    )}
                                                </div>

                                                <div className="checkItems">

                                                </div>

                                            </div>

                                            <div className="w-3/4 mt-4">

                                                <EmailInput
                                                    register={{ ...register("Email", { required: true }) }}
                                                    errors={
                                                        errors.Email &&
                                                        errors.Email.type === "required" && (
                                                            <Error
                                                                key={errorCount}
                                                                text={fieldRequiredMessage("Email Address")}
                                                            />
                                                        )
                                                    }
                                                    onChange={(e) => setValue("Email", e.target.value)}
                                                />

                                            </div>


                                        </div>
                                        <div className="min-w-full">
                                            <div className="flex items-center justify-center">
                                                <SubmitButton
                                                    buttonText={"Send Invitation To COC"}
                                                    loading={loading}
                                                    onClick={() => setErrorCount(errorCount + 1)}
                                                />
                                                {alert.message && alert.type === "alert-danger" && (
                                                    <Error key={errorCount} text={alert.message} />
                                                )}
                                            </div>
                                        </div>
                                    </form>
                                </Dialog.Panel>
                            </Transition.Child>
                        </div>


                    </div>
                </Dialog>
            </Transition>
        </>
    )
}